// extracted by mini-css-extract-plugin
export default {"container":"ActivityStartButton_container__Q4HOO","start_activity_btn":"ActivityStartButton_start_activity_btn__my65p"};